module.exports = __webpack_public_path__ + "static/img/a.febea8b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a.gif
// module id = 9fpJ
// module chunks = 1